import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styles from './navigationitem.module.scss';
import Image from '../Image';

function NavigationItem({ large, className, ...props }) {
  const cssClass = large ? [styles.item_lg] : [styles.item];
  const { url, navigation_image, navigation_title, style } = props;
  if (className) {
    cssClass.push(className);
  }
  return (
    <Link
      to={url}
      title={navigation_title}
      className={cssClass.join(' ')}
      style={style}
    >
      <span className={styles.overlay}>
        <span className={styles.title}>{navigation_title}</span>
      </span>
      <img
        className={styles.img}
        src={navigation_image.url}
        alt={navigation_title}
      />
  </Link>
  );
}

NavigationItem.defaultProps = {

};

NavigationItem.propTypes = {

};

export default NavigationItem;



// WEBPACK FOOTER //
// ./src/components/NavigationItem/index.jsx